import type { FC } from 'react'
import type { Document } from '@contentful/rich-text-types'
import styled from '@emotion/styled'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'
import RichText from '@segment/matcha/recipes/RichText'

import { useActiveState } from '@segment/utils/useActiveState'

interface TranscriptProps {
  heading: string
  id: string
  content: Document
}
const Transcript: FC<TranscriptProps> = ({ heading, id, content }) => {
  const { activeItems, toggle } = useActiveState([false])
  return (
    <Wrapper>
      {activeItems.map((active, index) => (
        <AccordionBase key={`item-${index}`}>
          <Accordion.Header onClick={() => toggle(index)}>
            <Accordion.TitleWrapper>
              <Accordion.Title variant="h2" opened={active} id={id}>
                {heading}
              </Accordion.Title>
            </Accordion.TitleWrapper>
            <Accordion.Icon opened={active} />
          </Accordion.Header>
          <Accordion.Body>
            {active && (
              <Accordion.ContentWrapper>
                <Accordion.Text>
                  <RichText data={content} />
                </Accordion.Text>
              </Accordion.ContentWrapper>
            )}
          </Accordion.Body>
        </AccordionBase>
      ))}
    </Wrapper>
  )
}

export default Transcript

const Wrapper = styled.section``
